// extracted by mini-css-extract-plugin
module.exports = {"input":"TRgo7P6i","description":"iMnXFLCT","grid":"_2JusEzZp","column":"gGEfxVO9"};